import get from 'lodash.get';

const getButtonPresets = (state) => get(state, 'ws.template.meta.customization.buttonPresets', []);

export default getButtonPresets;
